import '/assets/js/lib/comical.bundle.js';
// Upewniamy się, że globalne obiekty są eksportowane modułowo
export const Comical = window.Comical;
export const Bubble = window.Bubble;
export const BubbleSpec = window.BubbleSpec;
export const BubbleSpecPattern = window.BubbleSpecPattern;
export const TailSpec = window.TailSpec;